import axios from "axios";

import { STORAGE_KEYS, URI } from "../../utils/constants";

const defaultQueryConfig = {
  refetchOnWindowFocus: false,
};

export const CONFIG_QUERY = {
  default: {
    ...defaultQueryConfig,
  },
  entity: {
    ...defaultQueryConfig,
    cacheTime: 0,
  },
  entities: {
    ...defaultQueryConfig,
    // staleTime: 1000 * 60 * 5,
    staleTime: 0,
    cacheTime: 0,
  },
  noCache: {
    ...defaultQueryConfig,
    staleTime: 0,
    cacheTime: 0,
  },
  deferred: {
    ...defaultQueryConfig,
    staleTime: 1000 * 60 * 30,
  },
  rare: {
    ...defaultQueryConfig,
    staleTime: 1000 * 60 * 60 * 2,
  },
  infinite: {
    ...defaultQueryConfig,
    staleTime: Infinity,
    cacheTime: Infinity,
  },
};

export const getAxiosConfig = () => ({
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage[STORAGE_KEYS.AUTH_TOKEN]}`,
  },
});

const get = (path, config) => axios.get(`${URI.API}${path}`, config || getAxiosConfig());

const post = (path, body, config) =>
  axios.post(`${URI.API}${path}`, body, config || getAxiosConfig());

const put = (path, body, config) =>
  axios.put(`${URI.API}${path}`, body, config || getAxiosConfig());

const del = (path, config) =>
  axios.delete(`${URI.API}${path}`, config || getAxiosConfig());

const http = {
  get,
  post,
  put,
  del,
};

export default http;
